import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper
} from '@mui/material';
import GradeListItem from './GradeListItem';
import { useTranslation } from "react-i18next";

const getGradeForMP = (learningObjectiveGrades, mpId) => {
  if (!Array.isArray(learningObjectiveGrades) || !mpId) return '';
  const gradeObj = learningObjectiveGrades.find(g => String(g.markingPeriodId) === String(mpId));
  return gradeObj?.grade !== undefined && gradeObj?.grade !== null ? gradeObj.grade : '';
}

export default function GradeList({ studentStandardBasedGrades, markingPeriods, gradeLetters }) {
  const { t } = useTranslation();

  const hasData = Array.isArray(studentStandardBasedGrades) && studentStandardBasedGrades.length > 0;
  const hasMarkingPeriods = Array.isArray(markingPeriods) && markingPeriods.length > 0;

  return (
    <TableContainer component={Paper} sx={{ mt: 5 }}>
      <Table stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell
              align='left'
              sx={{
                backgroundColor: 'primary.main',
                color: 'primary.contrastText',
                fontWeight: 'bold',
                width: '50%',
              }}
            >
              {t('Learning Standard')}
            </TableCell>
            {hasMarkingPeriods ? (
              markingPeriods.map((mp) => (
                <TableCell
                  key={mp.id}
                  align='center'
                  sx={{
                    backgroundColor: 'primary.main',
                    color: 'primary.contrastText',
                    fontWeight: 'bold',
                    width: `${50 / markingPeriods.length}%`,
                  }}
                >
                  {mp.name}
                </TableCell>
              ))
            ) : (
              <TableCell
                align='center'
                sx={{
                  backgroundColor: 'primary.main',
                  color: 'primary.contrastText',
                  fontWeight: 'bold',
                }}
              >
                {t('Marking Periods')}
              </TableCell>
            )}
          </TableRow>
        </TableHead>
        <TableBody>

          {!hasData ? (
            <TableRow>
              <TableCell colSpan={hasMarkingPeriods ? markingPeriods.length + 1 : 2} align="center">
                {t('No learning standards available')}
              </TableCell>
            </TableRow>
          ) : (
            studentStandardBasedGrades.map((item, index) => (
              <GradeListItem
                key={item.id || `standard-${index}`}
                item={item}
                markingPeriods={markingPeriods}
                getGradeForMP={getGradeForMP}
                gradeLetters={gradeLetters} 
              />
            ))
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}